angular.module('satv.track')
    .controller('SelectTrackModalCtrl', ['$scope', 'TrackLoader', '$controller', function ($scope, TrackLoader, $controller) {
        'use strict';
        angular.extend(this, $controller('BaseSelectModalCtrl', {
            $scope: $scope,
            Loader: TrackLoader,
            FormModal: null
        }));
    }]);


// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/controllers/SelectTrackModalCtrl.js